const selectors = {
  dropdown: "[data-dropdown]",
  dropdownTrigger: "[data-dropdown-trigger]",
  dropdownItem: "[data-dropdown-item]",
  dropdownSelect: "[data-dropdown-select]",
};

const classes = {
  active: "active",
};

export const initDropdowns = (dropdown) => {
  const triggers = dropdown.querySelectorAll(selectors.dropdownTrigger);
  const items = dropdown.querySelectorAll(selectors.dropdownItem);
  const select = dropdown.querySelector(selectors.dropdownSelect);

  items?.forEach((item, activeIndex) =>
    item.addEventListener("click", () => {
      dropdown.classList.remove(classes.active);
      select.innerText = item.innerText;
      items.forEach((item, index) =>
        item.setAttribute("data-dropdown-item", activeIndex === index)
      );
    })
  );

  triggers?.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      dropdown.classList.toggle(classes.active);
    });
  });
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const dropdowns = document.querySelectorAll(selectors.dropdown);

    dropdowns?.forEach(initDropdowns);
  },
  {
    once: true,
  }
);
